import { type RouteConfig } from 'vue-router'

export const LoginRouter: RouteConfig[] = [
  {
    path: '/login',
    component: async () => import('./Login.vue'),
  },
]
